export default "__VITE_ASSET__Cl50cHcB__"